"use client";

import React, { useMemo } from "react";
import s from "./spinner.module.css";
interface Props {
  size?: "small" | "medium" | "large";
  className?: string;
}

type NativeAttrs = Omit<React.HTMLAttributes<any>, keyof Props>;
export type SpinnerProps = Props & NativeAttrs;

const getSpans = (color?: string) => {
  return [...new Array(12)].map((_, index) => (
    <span
      className={`${s.slice} absolute ${
        color ? color : "bg-foreground"
      } rounded-lg`}
      key={`spinner-${index + 1}`}
    ></span>
  ));
};

const getWidth = (size: "small" | "medium" | "large") => {
  const widths: { [key in "small" | "medium" | "large"]: string } = {
    small: ".75rem",
    medium: "1rem",
    large: "1.25rem",
  };

  return widths[size];
};

export const Spinner: React.FC<SpinnerProps> = ({
  size = "medium",
  className = "",
  color,
  ...props
}) => {
  const width = useMemo(() => getWidth(size), [size]);

  return (
    <div
      className={`${s.spinner} ${className}`}
      style={{
        width: width,
        height: width,
      }}
      {...props}
    >
      <div className={s.container}>{getSpans(color)}</div>
    </div>
  );
};

export default Spinner;
